// Additional portal / admin / client translation keys, merged with the base dictionary.
export const portalDict = {
  de: {
    "nav.overview": "Übersicht",
    "nav.documents": "Dokumente",
    "nav.signatures": "Unterschriften",
    "nav.verification": "Verifizierung",
    "nav.audit": "Prüfprotokoll",
    "nav.vault": "Tresor",
    "nav.settings": "Einstellungen",
    "nav.support": "Support",

    "portal.title": "Treuhand-Portal",
    "portal.welcome": "Willkommen",
    "portal.logout": "Abmelden",
    "portal.secure": "Gesicherte Verbindung",
    "portal.footer.tagline": "Vertrauen · Diskretion · Präzision",
    "portal.footer.sub": "Premium Treuhand- & Zahlungsvermittlung",
    "portal.live": "Live",
    "portal.enc.title": "256-BIT-VERSCHLÜSSELUNG",
    "portal.enc.sub": "Sicherheit auf Bankniveau",
    "portal.notifications": "Benachrichtigungen",
    "portal.theme": "Ansicht wechseln (hell/dunkel)",
    "notif.empty": "Keine neuen Benachrichtigungen",
    "filter.all": "Alle",
    "portal.role.admin": "Administrator",
    "portal.role.client": "Premium-Mandant",
    "portal.section.overview": "Übersicht",
    "portal.section.overview.sub": "Sicher · Verschlüsselt · Treuhänderisch",
    "portal.section.documents": "Dokumente",
    "portal.section.documents.sub": "Verträge & treuhänderische Unterlagen",
    "portal.section.signatures": "Unterschriften",
    "portal.section.signatures.sub": "Digitale Signaturen & Freigaben",
    "portal.section.verification": "Verifizierung",
    "portal.section.verification.sub": "Identität & Legitimation",
    "portal.section.audit": "Prüfprotokoll",
    "portal.section.audit.sub": "Lückenlose Vorgangshistorie",
    "portal.section.vault": "Tresor",
    "portal.section.vault.sub": "Verschlüsselte Bankverbindung",
    "portal.section.settings": "Einstellungen",
    "portal.section.settings.sub": "Konto & Präferenzen",
    "portal.section.support": "Support",
    "portal.section.support.sub": "Persönliche Betreuung",

    "portal.overview": "Übersicht",
    "portal.new": "Neuer Vorgang",
    "portal.total": "Gesamtvolumen",
    "portal.active": "Aktive Vorgänge",
    "portal.released": "Freigegeben",
    "portal.transactions": "Transaktionen",
    "portal.noTx": "Noch keine Vorgänge angelegt.",
    "portal.reference": "Referenz",
    "portal.investor": "Anleger",
    "portal.amount": "Betrag",
    "portal.targetBank": "Zielbank",
    "portal.status": "Status",
    "portal.created": "Erstellt",
    "portal.actions": "Aktionen",
    "portal.form.title": "Neuen Treuhandvorgang anlegen",
    "portal.form.purposeCode": "Verwendungszweck-Code",
    "portal.form.investor": "Name des Anlegers",
    "portal.form.amount": "Betrag",
    "portal.form.currency": "Währung",
    "portal.form.targetBank": "Zielbank / Institut",
    "portal.form.iban": "IBAN des Zielkontos (optional)",
    "portal.form.notes": "Notizen (optional)",
    "portal.form.submit": "Vorgang anlegen",
    "portal.form.cancel": "Abbrechen",
    "portal.action.markSent": "Als gesendet markieren",
    "portal.action.markReceived": "Geldeingang bestätigen",
    "portal.action.release": "An Bank freigeben",
    "portal.action.delete": "Löschen",
    "portal.profile.title": "Institutsprofil vervollständigen",
    "portal.profile.subtitle": "Bitte hinterlegen Sie Ihre Institutsdaten, um Vorgänge anzulegen.",
    "portal.profile.save": "Profil speichern",

    "section.empty": "In diesem Bereich sind derzeit keine Einträge vorhanden.",
    "section.docs.title": "Ihre Dokumente",
    "section.audit.title": "Prüfprotokoll",
    "section.vault.title": "Verschlüsselter Tresor",
    "section.settings.acct": "Kontoeinstellungen",
    "section.support.title": "Persönliche Betreuung",
    "sighist.title": "Signatur-Verlauf",

    "client.stepper.order": "Auftrag",
    "client.stepper.phase": "Aktuelle Phase",
    "client.badge": "Verifiziertes Treuhandkonto",
    "client.bank.title": "Ihr Treuhandkonto",
    "client.bank.status": "Automatisch verifiziert & verknüpft",
    "client.bank.desc": "Ihr Konto wurde automatisch über das gesicherte Bankennetzwerk verifiziert und mit dem Treuhandsystem verknüpft.",
    "client.bank.holder": "Kontoinhaber",
    "client.bank.iban": "IBAN",
    "client.bank.bic": "BIC / SWIFT",
    "client.bank.bank": "Institut",
    "client.bank.reference": "Referenz",
    "client.bank.provisioned": "Verknüpft am",
    "client.secured": "Ende-zu-Ende gesichert · BaFin-konform · Vollständig versichert",
    "client.tx.title": "Ihre Treuhandvorgänge",
    "client.tx.subtitle": "Live-Status Ihrer Zahlungsabwicklungen",
    "client.tx.none": "Zurzeit sind keine Vorgänge hinterlegt.",
    "client.identity.title": "Ihre hinterlegten Daten",
    "client.identity.desc": "Diese Angaben wurden verifiziert und sind schreibgeschützt.",
    "client.identity.fullName": "Name",
    "client.identity.idType": "Ausweisart",
    "client.identity.idNumber": "Ausweisnummer",
    "client.identity.birthDate": "Geburtsdatum",
    "client.identity.nationality": "Staatsangehörigkeit",
    "client.identity.verified": "Verifiziert",
    "client.ref.title": "Vorgang aufrufen",
    "client.ref.subtitle": "Bitte geben Sie Ihren Referenzcode ein, um Ihren Vorgang zu laden.",
    "client.ref.placeholder": "z. B. AN-XXXX-XXXX",
    "client.ref.submit": "Vorgang laden",
    "client.ref.invalid": "Kein Vorgang mit diesem Referenzcode gefunden.",
    "client.ref.reset": "Anderen Code eingeben",
    "client.ref.secured": "Gesicherte Verbindung · Ende-zu-Ende verschlüsselt",
    "client.pay.title": "Überweisungsauftrag",
    "client.pay.instruction": "Bitte überweisen Sie den folgenden Betrag an das angegebene Konto. Der Vorgang startet automatisch, sobald Sie die Überweisung bestätigen.",
    "client.pay.recipient": "Empfänger",
    "client.pay.iban": "IBAN",
    "client.pay.bic": "BIC / SWIFT",
    "client.pay.bank": "Bank",
    "client.pay.amount": "Betrag",
    "client.pay.purpose": "Verwendungszweck",
    "client.pay.product": "Anlageart",
    "client.pay.settlement": "Auszahlungsbank",
    "client.pay.settlement.note": "Nach Freigabe durch das Notariat wird das Guthaben auf Ihren Namen bei der oben genannten Bank gutgeschrieben.",
    "client.pay.confirm": "Überweisung erledigt",
    "client.pay.confirming": "Wird verarbeitet…",
    "client.pay.confirmHint": "Tippen Sie erst, nachdem Sie die Überweisung bei Ihrer Bank ausgeführt haben.",
    "client.pay.done": "Überweisung bestätigt – Ihr Vorgang wird bearbeitet.",
    "client.process.title": "Status Ihres Vorgangs",
    "client.step.awaiting": "Warten auf Ihre Überweisung",
    "client.step.reported": "Überweisung gemeldet",
    "client.step.received": "Zahlungseingang bestätigt",
    "client.step.released": "An Bank freigegeben",
    "client.step.reportedDesc": "Ihre Zahlung wurde erfasst und wird geprüft.",
    "client.step.receivedDesc": "Der Zahlungseingang wurde im Treuhandkonto bestätigt.",
    "client.step.releasedDesc": "Der Betrag wurde an das Zielinstitut freigegeben.",
    "client.docs.title": "Ihre Dokumente",
    "client.docs.hint": "Von Aureus Notariat bereitgestellte Unterlagen. Alle Dateien sind verschlüsselt gespeichert.",
    "client.docs.download": "Herunterladen",
    "client.docs.view": "Ansehen",
    "client.docs.empty": "Es liegen derzeit keine Dokumente für Sie vor.",
    "client.video.badge": "Video",
    "client.video.title": "Willkommen – Bankgeschäfte, diskret.",
    "client.video.subtitle": "Sie entscheiden über Ihr Kapital und über Ihre Anlage – nicht Ihr Hausbank-Berater. Setzen Sie eine klare Grenze.",
    "client.video.watch": "Video ansehen",
    "client.video.unsupported": "Ihr Browser unterstützt keine Videowiedergabe.",

    "support.title": "Ihre Ansprechpartner",
    "support.subtitle": "Ihr persönliches Team bei Aureus Notariat – jederzeit per E-Mail erreichbar.",
    "support.email": "E-Mail schreiben",
    "support.phone": "Telefon",
    "support.loading": "Ansprechpartner werden geladen …",
    "support.empty": "Derzeit sind keine Ansprechpartner hinterlegt.",

    "admin.badge": "Administrator",
    "admin.title": "Administration",
    "admin.subtitle": "Kunden, Bankverbindungen und Treuhandvorgänge verwalten",
    "admin.clients.count": "Kunden gesamt",
    "admin.volume.total": "Verwahrtes Volumen",
    "admin.tx.total": "Vorgänge gesamt",
    "admin.clients.title": "Kunden",
    "admin.newClient": "Kunde anlegen",
    "admin.noClients": "Noch keine Kunden angelegt.",
    "admin.col.client": "Kunde",
    "admin.col.bank": "Bankverbindung",
    "admin.col.volume": "Volumen",
    "admin.col.tx": "Vorgänge",
    "admin.col.actions": "Aktionen",
    "admin.manage": "Verwalten",
    "admin.deleteClient": "Kunde löschen",
    "admin.confirmDelete": "Diesen Kunden und alle zugehörigen Daten unwiderruflich löschen?",
    "admin.noBank": "Keine Bankverbindung",
    "admin.form.title": "Neuen Kunden anlegen",
    "admin.form.subtitle": "Zugangsdaten und Bankverbindung werden für den Kunden bereitgestellt.",
    "admin.form.section.access": "Zugangsdaten",
    "admin.form.section.bank": "Bankverbindung",
    "admin.form.section.identity": "Ausweisdaten",
    "admin.form.name": "Name des Ansprechpartners",
    "admin.form.institution": "Name des Instituts",
    "admin.form.type": "Art des Instituts",
    "admin.form.email": "E-Mail (Login)",
    "admin.form.password": "Passwort",
    "admin.form.accountHolder": "Kontoinhaber",
    "admin.form.iban": "IBAN",
    "admin.form.bic": "BIC / SWIFT (optional)",
    "admin.form.bankName": "Bank",
    "admin.form.currency": "Währung",
    "admin.form.idFullName": "Vollständiger Name (lt. Ausweis)",
    "admin.form.idType": "Ausweisart",
    "admin.form.idNumber": "Ausweisnummer",
    "admin.form.birthDate": "Geburtsdatum",
    "admin.form.nationality": "Staatsangehörigkeit",
    "admin.form.create": "Kunde anlegen",
    "admin.form.cancel": "Abbrechen",
    "admin.detail.back": "Zurück zur Übersicht",
    "admin.detail.bankTitle": "Hinterlegte Bankverbindung",
    "admin.detail.editBank": "Bearbeiten",
    "admin.detail.saveBank": "Speichern",
    "admin.detail.identityTitle": "Hinterlegte Ausweisdaten",
    "admin.detail.editIdentity": "Bearbeiten",
    "admin.detail.saveIdentity": "Speichern",
    "admin.detail.noIdentity": "Keine Ausweisdaten hinterlegt.",
    "admin.detail.txTitle": "Vorgänge des Kunden",
    "admin.detail.newTx": "Vorgang anlegen",
    "admin.detail.since": "Kunde seit",
    "admin.action.confirmReceived": "Zahlungseingang bestätigen (Grün)",
    "admin.action.release": "An Bank freigeben",
    "admin.allTx.title": "Alle Vorgänge",
    "admin.central.note": "Die Verwaltung erfolgt zentral über die Übersicht. Wählen Sie dort einen Mandanten, um Bankverbindung, Ausweisdaten und Vorgänge zu bearbeiten.",
    "admin.docs.title": "Dokumente des Mandanten",
    "admin.docs.hint": "Laden Sie Unterlagen in den Account des Mandanten hoch. Der Mandant sieht sie im Bereich „Dokumente“.",
    "admin.docs.upload": "Dokument hochladen",
    "admin.docs.docTitle": "Bezeichnung",
    "admin.docs.docType": "Dokumentart",
    "admin.docs.file": "Datei (PDF, Word, Bild oder Video)",
    "admin.docs.save": "Hochladen",
    "admin.docs.uploading": "Wird hochgeladen …",
    "admin.docs.empty": "Für diesen Mandanten wurden noch keine Dokumente hochgeladen.",
    "admin.idType.id": "Personalausweis",
    "admin.idType.passport": "Reisepass",
    "admin.idType.residence": "Aufenthaltstitel",
    "admin.product.none": "Keine Angabe",
    "admin.product.festgeld": "Festgeld",
    "admin.product.tagesgeld": "Tagesgeld",
    "docType.welcomeVideo": "Willkommensvideo (für alle Mandanten sichtbar)",
    "docType.subscription": "Zeichnungsschein",
    "docType.fixedDeposit": "Festgeldvertrag",
    "docType.contract": "Vertrag",
    "docType.statement": "Kontoauszug / Abrechnung",
    "docType.kyc": "Legitimation / KYC",
    "docType.other": "Sonstiges",
  },
  en: {
    "nav.overview": "Overview",
    "nav.documents": "Documents",
    "nav.signatures": "Signatures",
    "nav.verification": "Verification",
    "nav.audit": "Audit Trail",
    "nav.vault": "Vault",
    "nav.settings": "Settings",
    "nav.support": "Support",

    "portal.title": "Escrow Portal",
    "portal.welcome": "Welcome",
    "portal.logout": "Sign out",
    "portal.secure": "Secure connection",
    "portal.footer.tagline": "Trust · Privacy · Precision",
    "portal.footer.sub": "Premium escrow & payment settlement",
    "portal.live": "Live",
    "portal.enc.title": "256-BIT ENCRYPTION",
    "portal.enc.sub": "Bank-level security",
    "portal.notifications": "Notifications",
    "portal.theme": "Switch appearance (light/dark)",
    "notif.empty": "No new notifications",
    "filter.all": "All",
    "portal.role.admin": "Administrator",
    "portal.role.client": "Premium Client",
    "portal.section.overview": "Overview",
    "portal.section.overview.sub": "Secure · Encrypted · Fiduciary",
    "portal.section.documents": "Documents",
    "portal.section.documents.sub": "Contracts & fiduciary records",
    "portal.section.signatures": "Signatures",
    "portal.section.signatures.sub": "Digital signatures & approvals",
    "portal.section.verification": "Verification",
    "portal.section.verification.sub": "Identity & legitimation",
    "portal.section.audit": "Audit Trail",
    "portal.section.audit.sub": "Complete transaction history",
    "portal.section.vault": "Vault",
    "portal.section.vault.sub": "Encrypted bank connection",
    "portal.section.settings": "Settings",
    "portal.section.settings.sub": "Account & preferences",
    "portal.section.support": "Support",
    "portal.section.support.sub": "Dedicated assistance",

    "portal.overview": "Overview",
    "portal.new": "New transaction",
    "portal.total": "Total volume",
    "portal.active": "Active transactions",
    "portal.released": "Released",
    "portal.transactions": "Transactions",
    "portal.noTx": "No transactions created yet.",
    "portal.reference": "Reference",
    "portal.investor": "Investor",
    "portal.amount": "Amount",
    "portal.targetBank": "Target bank",
    "portal.status": "Status",
    "portal.created": "Created",
    "portal.actions": "Actions",
    "portal.form.title": "Create new escrow transaction",
    "portal.form.purposeCode": "Purpose code",
    "portal.form.investor": "Investor name",
    "portal.form.amount": "Amount",
    "portal.form.currency": "Currency",
    "portal.form.targetBank": "Target bank / institution",
    "portal.form.iban": "Target account IBAN (optional)",
    "portal.form.notes": "Notes (optional)",
    "portal.form.submit": "Create transaction",
    "portal.form.cancel": "Cancel",
    "portal.action.markSent": "Mark as sent",
    "portal.action.markReceived": "Confirm funds received",
    "portal.action.release": "Release to bank",
    "portal.action.delete": "Delete",
    "portal.profile.title": "Complete institution profile",
    "portal.profile.subtitle": "Please provide your institution details to create transactions.",
    "portal.profile.save": "Save profile",

    "section.empty": "There are currently no entries in this section.",
    "section.docs.title": "Your documents",
    "section.audit.title": "Audit trail",
    "section.vault.title": "Encrypted vault",
    "section.settings.acct": "Account settings",
    "section.support.title": "Dedicated assistance",
    "sighist.title": "Signature History",

    "client.stepper.order": "Order",
    "client.stepper.phase": "Current phase",
    "client.badge": "Verified escrow account",
    "client.bank.title": "Your escrow account",
    "client.bank.status": "Automatically verified & linked",
    "client.bank.desc": "Your account was automatically verified through the secure banking network and linked to the escrow system.",
    "client.bank.holder": "Account holder",
    "client.bank.iban": "IBAN",
    "client.bank.bic": "BIC / SWIFT",
    "client.bank.bank": "Institution",
    "client.bank.reference": "Reference",
    "client.bank.provisioned": "Linked on",
    "client.secured": "End-to-end secured · BaFin-compliant · Fully insured",
    "client.tx.title": "Your escrow transactions",
    "client.tx.subtitle": "Live status of your payment settlements",
    "client.tx.none": "No transactions on file at the moment.",
    "client.identity.title": "Your registered details",
    "client.identity.desc": "These details have been verified and are read-only.",
    "client.identity.fullName": "Name",
    "client.identity.idType": "ID type",
    "client.identity.idNumber": "ID number",
    "client.identity.birthDate": "Date of birth",
    "client.identity.nationality": "Nationality",
    "client.identity.verified": "Verified",
    "client.ref.title": "Access your transaction",
    "client.ref.subtitle": "Please enter your reference code to load your transaction.",
    "client.ref.placeholder": "e.g. AN-XXXX-XXXX",
    "client.ref.submit": "Load transaction",
    "client.ref.invalid": "No transaction found for this reference code.",
    "client.ref.reset": "Enter a different code",
    "client.ref.secured": "Secure connection · End-to-end encrypted",
    "client.pay.title": "Transfer order",
    "client.pay.instruction": "Please transfer the amount below to the account shown. The process starts automatically once you confirm the transfer.",
    "client.pay.recipient": "Recipient",
    "client.pay.iban": "IBAN",
    "client.pay.bic": "BIC / SWIFT",
    "client.pay.bank": "Bank",
    "client.pay.amount": "Amount",
    "client.pay.purpose": "Payment reference",
    "client.pay.product": "Investment type",
    "client.pay.settlement": "Settlement bank",
    "client.pay.settlement.note": "After release by the notary, the funds will be credited in your name at the bank shown above.",
    "client.pay.confirm": "Transfer completed",
    "client.pay.confirming": "Processing…",
    "client.pay.confirmHint": "Only tap after you have executed the transfer at your bank.",
    "client.pay.done": "Transfer confirmed — your transaction is being processed.",
    "client.process.title": "Status of your transaction",
    "client.step.awaiting": "Awaiting your transfer",
    "client.step.reported": "Transfer reported",
    "client.step.received": "Funds received confirmed",
    "client.step.released": "Released to bank",
    "client.step.reportedDesc": "Your payment has been registered and is being reviewed.",
    "client.step.receivedDesc": "Receipt of funds has been confirmed in the escrow account.",
    "client.step.releasedDesc": "The amount has been released to the target institution.",
    "client.docs.title": "Your documents",
    "client.docs.hint": "Documents provided by Aureus Notariat. All files are stored encrypted.",
    "client.docs.download": "Download",
    "client.docs.view": "View",
    "client.docs.empty": "There are currently no documents for you.",
    "client.video.badge": "Video",
    "client.video.title": "Welcome — Banking, Discreet.",
    "client.video.subtitle": "You decide about your capital and your investment — not your house-bank advisor. Set a clear boundary.",
    "client.video.watch": "Watch video",
    "client.video.unsupported": "Your browser does not support video playback.",

    "support.title": "Your points of contact",
    "support.subtitle": "Your dedicated team at Aureus Notariat — reachable by email at any time.",
    "support.email": "Send email",
    "support.phone": "Phone",
    "support.loading": "Loading contacts …",
    "support.empty": "No points of contact are configured yet.",

    "admin.badge": "Administrator",
    "admin.title": "Administration",
    "admin.subtitle": "Manage clients, bank connections and escrow transactions",
    "admin.clients.count": "Total clients",
    "admin.volume.total": "Assets held in escrow",
    "admin.tx.total": "Total transactions",
    "admin.clients.title": "Clients",
    "admin.newClient": "Create client",
    "admin.noClients": "No clients created yet.",
    "admin.col.client": "Client",
    "admin.col.bank": "Bank connection",
    "admin.col.volume": "Volume",
    "admin.col.tx": "Transactions",
    "admin.col.actions": "Actions",
    "admin.manage": "Manage",
    "admin.deleteClient": "Delete client",
    "admin.confirmDelete": "Permanently delete this client and all associated data?",
    "admin.noBank": "No bank connection",
    "admin.form.title": "Create new client",
    "admin.form.subtitle": "Login credentials and bank connection are provisioned for the client.",
    "admin.form.section.access": "Login credentials",
    "admin.form.section.bank": "Bank connection",
    "admin.form.section.identity": "ID data",
    "admin.form.name": "Contact person name",
    "admin.form.institution": "Institution name",
    "admin.form.type": "Institution type",
    "admin.form.email": "Email (login)",
    "admin.form.password": "Password",
    "admin.form.accountHolder": "Account holder",
    "admin.form.iban": "IBAN",
    "admin.form.bic": "BIC / SWIFT (optional)",
    "admin.form.bankName": "Bank",
    "admin.form.currency": "Currency",
    "admin.form.idFullName": "Full name (as on ID)",
    "admin.form.idType": "ID type",
    "admin.form.idNumber": "ID number",
    "admin.form.birthDate": "Date of birth",
    "admin.form.nationality": "Nationality",
    "admin.form.create": "Create client",
    "admin.form.cancel": "Cancel",
    "admin.detail.back": "Back to overview",
    "admin.detail.bankTitle": "Provisioned bank connection",
    "admin.detail.editBank": "Edit",
    "admin.detail.saveBank": "Save",
    "admin.detail.identityTitle": "Provisioned ID data",
    "admin.detail.editIdentity": "Edit",
    "admin.detail.saveIdentity": "Save",
    "admin.detail.noIdentity": "No ID data on file.",
    "admin.detail.txTitle": "Client transactions",
    "admin.detail.newTx": "Create transaction",
    "admin.detail.since": "Client since",
    "admin.action.confirmReceived": "Confirm funds received (green)",
    "admin.action.release": "Release to bank",
    "admin.allTx.title": "All transactions",
    "admin.central.note": "Management is handled centrally from the Overview. Select a client there to edit their bank details, ID data, and transactions.",
    "admin.docs.title": "Client documents",
    "admin.docs.hint": "Upload documents into the client's account. The client sees them under \"Documents\".",
    "admin.docs.upload": "Upload document",
    "admin.docs.docTitle": "Label",
    "admin.docs.docType": "Document type",
    "admin.docs.file": "File (PDF, Word, image or video)",
    "admin.docs.save": "Upload",
    "admin.docs.uploading": "Uploading …",
    "admin.docs.empty": "No documents have been uploaded for this client yet.",
    "admin.idType.id": "National ID card",
    "admin.idType.passport": "Passport",
    "admin.idType.residence": "Residence permit",
    "admin.product.none": "Not specified",
    "admin.product.festgeld": "Fixed deposit",
    "admin.product.tagesgeld": "Instant-access deposit",
    "docType.welcomeVideo": "Welcome video (visible to all clients)",
    "docType.subscription": "Subscription form",
    "docType.fixedDeposit": "Fixed-deposit contract",
    "docType.contract": "Contract",
    "docType.statement": "Statement",
    "docType.kyc": "Legitimation / KYC",
    "docType.other": "Other",
  },
};
